import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { styles, utils, translations } from 'gipsy-misc'
import variables from 'assets/styles/variables'
import { UserPicture, Tooltip, Icon, RedDot, media } from 'gipsy-ui'

import { elementHasNotifications } from 'features/notifications/utils'
import {
  activateTeamMember,
  getTeamList,
  getArchiveTeamList,
  getTeamMembers,
  removeTeamMember
} from 'features/teamlist/store/actions'
import { openPopup } from 'features/popup/store/actions'
import { InviteUserInputId } from 'features/teamlist/components/inviteUserInput'
import { ContextMenuContainer, ContextMenu, ContextMenuItem } from 'gipsy-ui'

import IoCloseCircled from 'react-icons/lib/io/close-circled'

const propTypes = {
  active: PropTypes.object,
  onChange: PropTypes.func,
  members: PropTypes.array
}

const mapStateToProps = state => ({
  members: state.teamlist.teamMembers,
  active: state.teamlist.activeTeamMember,
  notifications: state.notifications.list
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      activateTeamMember,
      getTeamList,
      getArchiveTeamList,
      getTeamMembers,
      openPopup,
      removeTeamMember
    },
    dispatch
  )
})

export const scrollElementId = 'team-members'

class TeamMembers extends PureComponent {
  state = {
    scrollTop: 0,
    removeMode: false
  }

  componentDidMount() {
    this.scrollElement.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    this.scrollElement.removeEventListener('scroll', this.onScroll)
    clearTimeout(this.longPressTimeout)
  }

  onScroll = e => {
    this.setState({
      scrollTop: e.target.scrollTop
    })
  }

  handleLongPress = () => {
    this.longPressTimeout = setTimeout(() => {
      this.setState({ removeMode: true })
    }, 500)
  }

  handleLongRelease = () => {
    clearTimeout(this.longPressTimeout)
  }

  onClick = (e, user, index) => {
    if (this.state.removeMode) {
      this.setState({ removeMode: false })
      return
    }
    if (document.getElementById('container') && document.getElementById('container').scrollTo) {
      document.getElementById('container').scrollTo(0, 0)
    }
    this.props.actions.activateTeamMember(user)
  }

  remove = user => {
    this.props.actions.removeTeamMember(user)
  }

  render() {
    const { scrollTop, removeMode } = this.state
    const { notifications, active, members } = this.props

    const notificationElement = 'member'
    return (
      <TeamMemberContainer className="team-members-container">
        <TeamMembersDiv
          id={scrollElementId}
          onScroll={this.handleLongRelease}
          className="team-members"
          ref={ref => (this.scrollElement = ref)}>
          {members.map((member, index) => {
            const user = utils.user.toUser(member)
            const tooltipTop = index * 89 - 20 - scrollTop
            const hasNotification = !!elementHasNotifications(
              notifications,
              notificationElement,
              utils.user.getKey(member)
            )
            const canRemove = !hasNotification && !member.count
            const isSelected = utils.user.getKey(active) === utils.user.getKey(user)
            return (
              <ContextMenuContainer key={utils.user.getKey(member)}>
                {(ref, onContextMenu, closeMenu, isActive) => {
                  return (
                    <Fragment>
                      <User
                        key={utils.user.getKey(member)}
                        id={utils.user.getKey(member)}
                        onContextMenu={canRemove ? onContextMenu : undefined}
                        onClick={e => this.onClick(e, user, index)}
                        onTouchStart={this.handleLongPress}
                        onTouchEnd={this.handleLongRelease}
                        className="user"
                        active={isSelected}>
                        <UserPicture
                          shake={removeMode}
                          opacity={isSelected ? 1 : 0.5}
                          src={member.picture}
                          size={40}
                          border={isSelected ? `2px solid ` : `2px solid ${styles.colors.backgroundGreyColor}`}
                          style={{ boxSizing: 'content-box' }}>
                          <Badge className="badge">{member.count}</Badge>
                          {hasNotification && <AbsoluteRedDot />}
                          {canRemove && removeMode && (
                            <RemoveBadge
                              className="remove-badge"
                              onClick={e => {
                                this.remove(user)
                                e.stopPropagation()
                              }}>
                              <IoCloseCircled className="io-close-circled" value={{ className: 'io-close-circled' }} />
                            </RemoveBadge>
                          )}
                        </UserPicture>
                        <UserText className="user-text">{utils.user.getDisplayName(member)}</UserText>
                        <Tooltip
                          text={member.displayName || member.email || 'Unknown'}
                          vs={tooltipTop > 0 ? tooltipTop : 10}
                          hs={70}
                          position="bottom right"
                        />
                      </User>
                      <ContextMenu isActive={isActive} setRef={ref}>
                        <ContextMenuItem
                          disabled={!canRemove}
                          height={20}
                          onClick={() => {
                            closeMenu()
                            this.remove(user)
                          }}>
                          <Icon icon="Trash" size={16} />
                          <ContextMenuLabel>{translations.general.delete}</ContextMenuLabel>
                        </ContextMenuItem>
                      </ContextMenu>
                    </Fragment>
                  )
                }}
              </ContextMenuContainer>
            )
          })}
        </TeamMembersDiv>
        <UserButton
          className="user-button"
          onClick={() =>
            this.props.actions.openPopup({
              title: translations.teamlist.inviteUser.popup.title,
              message: translations.teamlist.inviteUser.message,
              button: translations.teamlist.inviteUser.popup.button,
              componentId: InviteUserInputId
            })
          }
          withBorder={true}>
          <IconHolder>
            <Icon icon="AddUser" fill={styles.colors.primaryColor} />
          </IconHolder>
          <AddUserSpan>{translations.teamlist.inviteUser.popup.button}</AddUserSpan>
        </UserButton>
      </TeamMemberContainer>
    )
  }
}

TeamMembers.propTypes = propTypes

const TeamMemberContainer = styled.div`
  position: fixed;
  left: ${variables.sidebarWidth};
  top: 0px;
  bottom: 0px;
  width: 96px;
  border-right: 1px solid ${styles.colors.borderColor};
  z-index: 100;
  background-color: ${variables.teamMembersBackgroundColor};
  display: flex;
  flex-direction: column;

  ${media['phone-wide']`
    flex-direction: row;
    position: fixed;
    left: 0;
    top: 0px;
    right: 0;
    width: 100%;
    height: ${variables.mobileTeamMembersHeight};
    padding-right: 0;
    bottom: initial;
    padding: 0;
    border: none;
    z-index: 80;
  }
  `}
`

const TeamMembersDiv = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  padding: 20px 10px; /* spacing between list and scrollbar */
  ${media['phone-wide']`
    flex-direction: row;
    align-items: center;
    height: 100%;
    padding: 0px;
    width: 100%;
  `}
`

const User = styled.div`
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  width: 75px;
  &:last-child {
    margin-right: 0;
  }
  /* TODO fix corner of tooltip !! */
  .tooltip {
    border-bottom-left-radius: 4px !important;
    border-top-left-radius: 16px !important;
  }
  color: ${props => (props.active ? styles.colors.primaryColor : '')};
  ${media['phone-wide']`
    margin-right: 10px;
    margin-bottom: 0px !important;
    .tooltip {
      display: none;
    }
  `};
`

const ContextMenuLabel = styled.div`
  margin-left: 8px;
  color: ${styles.colors.textLightColor};
`

const Badge = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  font-size: 8px;
  font-weight: bold;
  background-color: ${styles.colors.buttonDarkColor};
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 3px solid ${variables.teamMembersBackgroundColor};
  left: -6px;
  top: -6px;
`

const AbsoluteRedDot = styled(RedDot)`
  position: absolute;
  top: -6px;
  right: -6px;
`

const RemoveBadge = styled.div`
  position: absolute;
  right: -6px;
  top: -6px;
  display: flex;
  border: 2px solid white;
  border-radius: 50%;
  background-color: white;
  .io-close-circled {
    color: ${styles.colors.buttonDarkColor};
    border-radius: 50%;
  }
`

const UserText = styled.div`
  font-size: ${styles.fonts.fontSizeXSmall};
  font-weight: 500;
  max-width: 60px;
  text-align: center;
  padding-top: 5px;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const UserButton = styled.div`
  height: 88px;
  border-top: ${props => (props.withBorder ? '1px solid #ebeaee' : '')};
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  padding-top: 6px;
  padding-bottom: 6px;
  cursor: pointer;
  span {
    font: ${styles.fonts.primaryFont};
    font-size: ${styles.fonts.fontSizeXSmall};
    color: ${styles.colors.primaryColor};
  }

  ${media['phone-wide']`
    padding: 0px;
    height: 100%;
    justify-content: center;
    width: 150px;
    border-left: 1px solid #ebeaee;
  `}
`

const IconHolder = styled.div`
  width: 40px;
  height: 40px;
  background-color: #e0daf7;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 4px;
  .fa-user-plus {
    color: ${styles.colors.primaryColor};
    width: 20px;
    height: 100%;
  }
  border: ${props => (props.active ? `2px solid ${styles.colors.primaryColor}` : '2px solid transparent')};
  box-sizing: content-box !important;
  ${media['phone-wide']`
    margin-right: 12px;
    margin-left: 12px;
  `}
`

const AddUserSpan = styled.span`
  font-weight: 500;
  font-size: 11px;
`

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: true }
)(TeamMembers)



// WEBPACK FOOTER //
// ./src/features/teamlist/components/members/index.js